import { NgModule } from '@angular/core';
import { LoginRoutingModule } from './login-routing.module'
import { LoginComponent } from '../login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {DialogModule} from 'primeng/dialog';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    LoginRoutingModule,
    ReactiveFormsModule,
    CommonModule,
    DialogModule,FormsModule
  ],
  declarations: [    
    LoginComponent
  ]
})
export class LoginModule { }
